module.exports = __webpack_public_path__ + "static/section1-b03fe4ada556a64d489fa51c8655c8a8.png";